const URL = 'https://static.whenthen.com/images/logos/branding/social/';

export const SectionDesc = {
  graphic: {
    title: 'Your logo',
    description:
      'These will appear on your emails, invoices, credit notes checkout pages, and your customer’s self-serve portal.',
  },
  accent: {
    title: 'Primary color',
    description: 'This color will be used for buttons, links, and other highlights.',
  },
  button: {
    title: 'Button shape',
    description: 'Define how your Call-To-Actions (CTAs) look and feel to the user.',
  },
  social: {
    title: 'Social networks',
    description: 'Add your social platforms here.',
  },
  // template: {
  //   title: 'Email template',
  //   description: 'This will be the structure of your emails. You can edit the footer text below',
  // },
};

export const SOCIAL_NETWORK_MAP = [
  {
    key: 'facebook',
    url: `${URL}facebook.png`,
  },
  {
    key: 'twitter',
    url: `${URL}twitter.png`,
  },
  {
    key: 'whatsapp',
    url: `${URL}whatsapp.png`,
  },
  {
    key: 'discord',
    url: `${URL}discord.ico`,
  },
  {
    key: 'google',
    url: `${URL}google.ico`,
  },
  {
    key: 'instagram',
    url: `${URL}instagram.png`,
  },
  {
    key: 'linkedin',
    url: `${URL}linkedin.ico`,
  },
  {
    key: 'pinterest',
    url: `${URL}pinterest.png`,
  },
  {
    key: 'quora',
    url: `${URL}quora.ico`,
  },
  {
    key: 'reddit',
    url: `${URL}reddit.png`,
  },
  {
    key: 'telegram',
    url: `${URL}telegram.png`,
  },
  {
    key: 'tumblr',
    url: `${URL}tumblr.png`,
  },
  {
    key: 'vk',
    url: `${URL}vk.png`,
  },
  {
    key: 'wechat',
    url: `${URL}wechat.png`,
  },
  {
    key: 'youtube',
    url: `${URL}youtube.png`,
  },
  {
    key: 'behance',
    url: `${URL}behance.ico`,
  },
  {
    key: 'codesandbox',
    url: `${URL}codesandbox.ico`,
  },
  {
    key: 'dropbox',
    url: `${URL}dropbox.png`,
  },
  {
    key: 'github',
    url: `${URL}github.png`,
  },
  {
    key: 'messenger',
    url: `${URL}messenger.ico`,
  },
  {
    key: 'stackoverflow',
    url: `${URL}stackoverflow.png`,
  },
];
